import { ChangeDetectionStrategy, ChangeDetectorRef, Component, OnInit } from '@angular/core';
import { CmsService } from '@spartacus/core';
import { filter } from 'rxjs';

import { IPaymentMode, SdPaymentModeComponent } from '@seb/web-design-system/payment';
import { AbstractComponent } from '../abstract-component.component';
import { ComponentService, ImageService } from '../../../services';
import { PaymentModeComponentInterface } from '../../../models';

@Component({
  selector: 'wc-payment-mode',
  templateUrl: './payment-mode.component.html',
  changeDetection: ChangeDetectionStrategy.OnPush,
  standalone: true,
  imports: [SdPaymentModeComponent]
})
export class PaymentModeComponent extends AbstractComponent<PaymentModeComponentInterface> implements OnInit {
  paymentMode: IPaymentMode;
  titleHidden: boolean;

  constructor(
    private componentService: ComponentService,
    private imageService: ImageService,
    private cmsService: CmsService,
    private cdRef: ChangeDetectorRef
  ) {
    super();
  }

  override mandatoryFunction = (cmp: PaymentModeComponentInterface): boolean => {
    return !!cmp.headline;
  };

  ngOnInit(): void {
    this.subscriptions.add(
      this.cmsService.getContentSlot('ShoppingCart').subscribe((slotData) => {
        const uid = slotData?.components?.[0]?.uid;
        this.lazyLoadingService.setFirstUids(uid ? [uid] : []);
      })
    );

    this.subscriptions.add(
      this.component$.pipe(
        this.componentService.reloadComponentForArrayProperties(['medias']),
        filter((cmp) => this.mandatoryFunction(cmp))
      ).subscribe((cmp: PaymentModeComponentInterface) => {
        this.paymentMode = {
          mode: cmp.headline,
          medias: cmp.medias ? Object.values(cmp.medias).map((image) => this.imageService.normalizeMedia(image)) : []
        };
        this.titleHidden = cmp.titleHidden;
        this.setLoaded();
        this.cdRef.markForCheck();
      })
    );
  }
}
